import axios from "axios";
import {action$GoodpayFrontendApi} from "@/vendor/qconstants";
import {baseURL} from "@/api/xhr";
import {getBtaste} from "@/vendor/bootstrap";

// Server url
const baseUrl = baseURL;
const path = 'inbound/v/service';

const post = (xhrMsg, errorMessage, timeoutOverride) => {
  let timeout = 10000;
  if (timeoutOverride) {
    timeout = timeoutOverride;
  }
  let promiseData = {};
  Object.assign(promiseData, xhrMsg);
  let extend = {
    timeout: timeout,
    btaste: getBtaste(),
  };
  Object.assign(promiseData, extend);

  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: baseUrl + path,
      data: promiseData,
      headers: {"Content-Type": "application/json"},
    })
      .then((response) => {
        console.log('Apple POST response: ' + JSON.stringify(response));
        if (response.status < 300) {
          resolve(response.data);
        } else {
          console.log('POST response response not < 300');
          reject(new Error(errorMessage));
        }
      })
      .catch((error) => {
        console.log('POST error ', error);
        reject(error);
      });
  });
};

export const performValidation = (
  url,
  merchantIdentifier,
  displayName,
  domain
) => {
  console.log('do performValidation...');
  // https://developer.apple.com/forums/thread/49912
  const data = {
    url: url,
    body: {
      merchantIdentifier: merchantIdentifier,
      displayName: displayName,
      initiative: "web",
      initiativeContext: domain,
    },
  };
  let xhrMsg = {
    action: action$GoodpayFrontendApi,
      method: 'createSession',
    data: data,
  };
  // let msg = {
  //   action: action$GoodpayFrontendApi,
  //   method: 'createSession',
  //   data: data,
  // };
  //
  // return new Promise((resolve, reject) => {
  //   xhr.xhrSend(true, msg, (reply) => {
  //     if (reply.ok) {
  //       console.log('createSession was ok');
  //       resolve(reply.data);
  //     } else {
  //       reject(new Error('Error createSession for apple validation'));
  //     }
  //   }, (err) => {
  //     console.log(error);
  //     reject(error);
  //   });
  // });

  return post(xhrMsg, 'Could not get session');
};

// export const performApplePayDebit = (amount, currency, payment_data) => {
//   const data = {
//     payment_data: payment_data,
//     amount: amount,
//     currency: currency,
//   };
//   console.log('performApplePayDebit... data=' + JSON.stringify(data));
//   return post("/applepay/debit", data, "Could not perform debit");
// };
